import { render, staticRenderFns } from "./SettingsEsprit.vue?vue&type=template&id=5123734a&scoped=true&"
import script from "./SettingsEsprit.vue?vue&type=script&lang=js&"
export * from "./SettingsEsprit.vue?vue&type=script&lang=js&"
import style0 from "./SettingsEsprit.vue?vue&type=style&index=0&id=5123734a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5123734a",
  null
  
)

export default component.exports